import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { getDateWithFormat } from '../../helpers/Utils';

import { BOOKING_LIST_GET_LIST } from '../actions';

import { getBookingListSuccess, getBookingListError } from './actions';

import bookingListData from '../../data/booking.list.json';

const getBookingListRequest = async () => {
  const bookings = bookingListData.data;
  return await new Promise((success, fail) => {
    setTimeout(() => {
      success({ bookings });
    }, 2000);
  })
    .then((response) => response)
    .catch((error) => error);
};

function* getBookingListItems() {
  try {
    const response = yield call(getBookingListRequest);
    const { bookings } = response;
    //console.log(bookings);
    yield put(getBookingListSuccess(bookings));
  } catch (error) {
    yield put(getBookingListError(error));
  }
}
export function* watchGetList() {
  yield takeEvery(BOOKING_LIST_GET_LIST, getBookingListItems);
}

export default function* rootSaga() {
  yield all([fork(watchGetList)]);
}
